import dialog from '@/components/dialog'

export default Vue => {
	Vue.component('gydialog', dialog)
}
